import React from 'react';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { guaranteeChecks } from '../../data/landing';
export function Guarantee() {
  return <section className="bg-white py-16 sm:py-24" aria-labelledby="guarantee-title" data-id="element-134" data-mp="24moq560mm0lw">
      <div className="mx-auto max-w-4xl px-5" data-id="element-135" data-mp="29dokq4m9w6l8">
        <div className="grid items-center gap-8 md:grid-cols-[220px_1fr] md:gap-12" data-id="element-136" data-mp="29fhs5m4pmuua">
          <div className="mx-auto flex h-48 w-48 flex-col items-center justify-center rounded-full bg-navy-900 text-white ring-8 ring-brand-100 md:h-52 md:w-52" data-id="element-137" data-mp="2ec86o50v9idl">
            <ShieldCheckIcon className="h-10 w-10 text-brand-400" aria-hidden="true" data-id="element-138" data-mp="2obgyosc68mxb" />
            <span className="mt-1 font-display text-5xl font-black leading-none" data-id="element-139" data-mp="2scsph16s7e73">7</span>
            <span className="mt-1 text-xs font-extrabold uppercase tracking-[0.2em]" data-id="element-140" data-mp="2sagbt0823pzu">Day guarantee</span>
          </div>

          <div className="text-center md:text-left" data-id="element-141" data-mp="xyhzgpegadzq">
            <h2 id="guarantee-title" className="text-balance font-display text-[2rem] font-black leading-tight text-navy-900 sm:text-4xl" data-id="element-142" data-mp="xz9u9y0847oy">
              7-Day Total Satisfaction Guarantee
            </h2>
            <p className="mt-3 text-lg text-navy-900/75" data-id="element-143" data-mp="3ivdh7hv86114">Try the Hernia Clinical Playbook™ completely risk-free.</p>
            <ul className="mx-auto mt-5 inline-grid gap-2 text-left md:mx-0" data-id="element-144" data-mp="3dxbp67ftmrdi">
              {guaranteeChecks.map(item => <li key={item} className="flex gap-2.5 text-base font-medium text-navy-900" data-id="element-145" data-mp="feejw62rwg4p">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta-500" strokeWidth={3} aria-hidden="true" data-id="element-146" data-mp="ah4wevyy2eji" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-5 text-base leading-relaxed text-navy-900/75" data-id="element-147" data-mp="guita8zz53t">
              If within the first 7 days you decide that the material doesn’t provide the value you expected for your
              professional practice, you can request a refund according to the terms of the guarantee.
            </p>
            <p className="mt-4 font-bold text-navy-900" data-id="element-148" data-mp="1d8xlkxtkq6yo">
              No complicated explanations. No unnecessary processes.{' '}
              <span className="text-brand-600" data-id="element-149" data-mp="1h7omzh52oarl">7 days to review the material.</span>
            </p>
          </div>
        </div>

        <CtaButton className="mt-12" label="Try it risk-free for 7 days" data-id="element-150" data-mp="188tetzigwqln" />
      </div>
    </section>;
}